import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import { plainToClass } from "class-transformer";
import { ToolModel } from "../../store/models/tools/Tool";
import { ToolEditModel } from "../../store/models/tools/ToolUpdate";
import { ToolGridViewModel } from "../../store/models/tools/Tools";
import { getTenantId } from "@/store/helper";
let ToolModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let ToolModule = class ToolModule extends VuexModule {
        constructor() {
            super(...arguments);
            //Update
            this.updateTool = null;
            //List
            this.tools = [];
            this.apiNode = "Tool";
        }
        //Actions
        //List
        async GetTools() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.ListTools(plainToClass(ToolGridViewModel, data.listTools));
                return data;
            }
        }
        //Add
        async SaveTool(tool) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, tool);
        }
        //Get Tool by Id for Edit
        async GetToolDetailById(toolId) {
            var url = `${getTenantId()}/${this.apiNode}/` + toolId;
            let { data } = await service.get(url);
            if (data) {
                this.EditSelectedTool(plainToClass(ToolEditModel, data.updateTool));
                return data;
            }
        }
        //Edit Tool
        async EditTool(updateTool) {
            var url = `${getTenantId()}/${this.apiNode}/` + "updateTool";
            let { data } = await service.put(url, updateTool);
        }
        //Delete
        async DeleteTool(deleteId) {
            var url = `${getTenantId()}/${this.apiNode}/` + "DeleteTool/" + deleteId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        //mutations
        //List
        ListTools(Tool) {
            this.tools = Tool;
        }
        //Update
        EditSelectedTool(tool) {
            this.updateTool = tool;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], ToolModule.prototype, "GetTools", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof ToolModel !== "undefined" && ToolModel) === "function" ? _b : Object]),
        __metadata("design:returntype", Promise)
    ], ToolModule.prototype, "SaveTool", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof Guid !== "undefined" && Guid) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], ToolModule.prototype, "GetToolDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof ToolEditModel !== "undefined" && ToolEditModel) === "function" ? _e : Object]),
        __metadata("design:returntype", Promise)
    ], ToolModule.prototype, "EditTool", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof Guid !== "undefined" && Guid) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], ToolModule.prototype, "DeleteTool", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ToolModule.prototype, "ListTools", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof ToolEditModel !== "undefined" && ToolEditModel) === "function" ? _h : Object]),
        __metadata("design:returntype", void 0)
    ], ToolModule.prototype, "EditSelectedTool", null);
    ToolModule = __decorate([
        Module({ dynamic: true, store: store, name: "tools", namespaced: true })
    ], ToolModule);
    return ToolModule;
})();
export default getModule(ToolModule);
